
var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

$(function(){
    $('.caption-toggle').click(function(){
        $(this).parent('.caption').toggleClass('open');
    })

    $('.chapter-hero').each(function(){
        const $this = $(this);
        $this.find('.img-bg, .video-bg').each(function(){
            $bg = $(this);
            new ScrollMagic.Scene({triggerElement: $this[0]})
                .setTween($bg[0], {y: "50%", ease: Linear.easeNone})
                .addTo(controller);
        })

    })
})

